import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import { GlobalSearch, IconFile } from '@bbl-digital/snorre-v2'
import { useSelector } from 'react-redux'
import { getBbl } from 'shared/store/bbl'
import { getFileIcon } from 'shared/utils/file/fileIcon'

export const BblDocumentSearchHits = () => {
  const { loading, bblDocumentsHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const { data: bbl } = useSelector(getBbl)
  const bblShortName = bbl?.shortName

  const hasBblDocumentsHits = bblDocumentsHits?.hits?.length

  const goToBblDocument = (id: string) => {
    push(`/styrearbeid/arkiv/bbl/${id}`)
  }

  if (loading || !hasBblDocumentsHits) return null

  const Hits = () => {
    return bblDocumentsHits.hits?.map((item) => (
      <GlobalSearch.Item
        key={item.id}
        label={item.title}
        subtitle={item.filename}
        options={{
          renderHighlightsAsHtml: true,
        }}
        icon={
          <div className="flex items-center justify-center bg-surface-common-icon-highlight p-[4px] pr-[3px] min-h-[20px] min-w-[20px] rounded-card [&>svg]:!fill-surface-common-icon-color">
            {getFileIcon(item.mimeType, {
              size: 22,
            })}
          </div>
        }
        onClick={() => goToBblDocument(item.id)}
      />
    ))
  }

  return (
    <GlobalSearch.Group
      label={`Filer delt av ${bblShortName} `}
      title={`Filer delt av ${bblShortName} `}
    >
      <Hits />
    </GlobalSearch.Group>
  )
}
